<template>
    <div class="container">
        <legend>貸し本棚利用規約</legend>
        <div class="rule">
            <h3>総則</h3>
            <div class="mb-3">
                貸し本棚利用規約（以下、「本規約」）は、貸し本棚が提供するサービス（以下、「本サービス」）と、サービス利用者との間の合意事項であり、
                運営方針を明確化し、効率的な運用を目的として定められます。
                本サービスの利用登録者（以下、「ユーザー」）は、本規約を承認した上で利用登録を行うものとします。
            </div>
        </div>
        <div class="rule">
            <h3>細則</h3>
            <h4>第1条（適用）</h4>
            <div class="mb-3">
                本規約は、ユーザーと貸し本棚との間の本サービスの利用に関わる一切の関係に適用されるものとします。<br>
                貸し本棚は本サービスに関し、本規約のほか、ご利用にあたってのルール等、各種の定め（以下、「個別規定」といいます。）をすることがあります。これら個別規定はその名称のいかんに関わらず、本規約の一部を構成するものとします。<br>
                本規約の規定が前条の個別規定の規定と矛盾する場合には、本規約と個別規定が矛盾する場合、当該個別規定に特別な記載がある場合を除き、本規約の内容が優先されるものとします。
            </div>
            <h4>第2条（利用登録）</h4>
            <div class="mb-3">
                本サービスにおいては、登録希望者が本規約に同意の上、貸し本棚の定める方法によって利用登録を申請し、貸し本棚がこの承認を登録希望者に通知することによって、利用登録が完了するものとします。<br>
                貸し本棚は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあり、その理由については必要に応じて理由の概要を開示することがあります。
                <ol>
                    <li>本規約に違反したことがある者からの申請である場合</li>
                    <li>その他、貸し本棚が利用登録を相当でないと判断した場合</li>
                </ol>
            </div>
            <h4>第3条（ユーザーIDおよびパスワードの管理）</h4>
            <div class="mb-3">
                ユーザーは、自己の責任において、本サービスのユーザーIDおよびパスワードを適切に管理するものとします。<br>
                ユーザーは、いかなる場合にも、ユーザーIDおよびパスワードを第三者に譲渡または貸与し、もしくは第三者と共用することはできません。
                貸し本棚は、ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には、そのユーザーIDを登録しているユーザー自身による利用とみなします。<br>
                ユーザーID及びパスワードが第三者によって使用されたことによって生じた損害は、貸し本棚に故意又は重大な過失がある場合を除き、貸し本棚は一切の責任を負わないものとします。<br>
            </div>
            <h4>第4条（広告）</h4>
            <div class="mb-3">
                サービス運営のため、貸し本棚はサービス上に広告を設置することがあります。
                ユーザーはこれらの広告をスクリプトや不正なコード、その他の方法で利用不能な状態にしてはなりません。<br>
                故意に広告を利用できない状態にした場合、警告や利用の一時停止の措置が行われ、改善が見込まれない場合に限り利用登録を抹消することがあります。
            </div>
            <h4>第5条（禁止事項）</h4>
            <div class="mb-3">
                ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。
                <ol>
                    <li>法令または公序良俗に違反する行為</li>
                    <li>犯罪行為に関連する行為</li>
                    <li>貸し本棚、本サービスの他のユーザー、または第三者のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為</li>
                    <li>貸し本棚のサービスの運営を妨害するおそれのある行為</li>
                    <li>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
                    <li>不正アクセスをし、またはこれを試みる行為</li>
                    <li>他のユーザーに成りすます行為</li>
                    <li>貸し本棚のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為</li>
                    <li>貸し本棚、本サービスの他のユーザーまたは第三者の知的財産権、肖像権、プライバシー、名誉その他の権利または利益を侵害する行為</li>
                    <li>
                        以下の表現を含み、または含むと貸し本棚が判断する内容を本サービス上に投稿し、または送信する行為
                        <ol>
                            <li>他人を誹謗中傷し、攻撃する表現</li>
                            <li>人種、国籍、信条、性別、社会的身分、門地等による差別につながる表現</li>
                        </ol>
                    </li>
                    <li>
                        以下を目的とし、または目的とすると貸し本棚が判断する行為
                        <ol>
                            <li>営業、宣伝、広告、勧誘、その他営利を目的とする行為（貸し本棚の認めたものを除きます。）</li>
                            <li>性行為やわいせつな行為を目的とする行為</li>
                            <li>面識のない異性との出会いや交際を目的とする行為</li>
                            <li>他のユーザーに対する嫌がらせや誹謗中傷を目的とする行為</li>
                            <li>貸し本棚、本サービスの他のユーザー、または第三者に不利益、損害または不快感を与えることを目的とする行為</li>
                            <li>その他本サービスが予定している利用目的と異なる目的で本サービスを利用する行為</li>
                            <li>宗教活動または宗教団体への勧誘行為</li>
                            <li>その他、社会通念上著しく不適切と合理的に判断される行為</li>
                        </ol>
                    </li>
                </ol>
            </div>
            <h4>第6条（本サービスの提供の停止等）</h4>
            <div class="mb-3">
                貸し本棚は、以下のいずれかの事由があると判断した場合、本サービスの全部または一部の提供を停止または中断することができるものとします。
                サービスの停止は可能な限り事前に通知します。
                <ol>
                    <li>本サービスにかかるコンピュータシステムの保守点検または更新を行う場合</li>
                    <li>地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合</li>
                    <li>コンピュータまたは通信回線等が事故により停止した場合</li>
                    <li>その他、貸し本棚が本サービスの提供が困難と判断した場合</li>
                </ol>
                貸し本棚は、本サービスの提供の停止または中断により、ユーザーまたは第三者が被ったいかなる不利益または損害についても、一切の責任を負わないものとします。
            </div>
            <h4>第7条（著作権）</h4>
            <div class="mb-3">
                <ol>
                    <li>
                        ユーザーは、自ら著作権その他必要な権利を有するか、または適法に利用許諾を得た文章、画像、映像等の情報に限り、本サービスを通じて投稿またはアップロードできるものとします。
                    </li>
                    <li>
                        本サービスを通じて投稿またはアップロードされたコンテンツに係る著作権その他の知的財産権は、当該ユーザーまたは原権利者に帰属します。ただし、貸し本棚は、当該コンテンツを以下の目的の範囲内で、無償かつ非独占的に利用（複製、公衆送信、表示、翻案等を含む）できるものとし、ユーザーは著作者人格権を行使しないものとします。
                        <ul>
                            <li>
                                本サービスの表示および機能提供に必要な範囲
                            </li>
                            <li>
                                不具合修正、品質改善、ユーザーサポート等のサービス運営目的
                            </li>
                            <li>
                                本サービスの周知・宣伝のための利用（サンプル掲載等。ただし、明確な同意が必要な場合は個別に確認します）
                            </li>
                        </ul>
                    </li>
                    <li>
                        ユーザーは、他のユーザーの投稿を含む本サービス上のコンテンツについて、以下の行為を行わないものとします。
                        <ul>
                            <li>
                                当該ユーザーまたは貸し本棚の許諾なく、機械学習・人工知能モデルその他の自動処理技術による収集、解析、再利用、または学習への利用を行うこと
                            </li>
                            <li>
                                コンテンツを機械学習目的で大量にダウンロード・保存・再構成すること
                            </li>
                        </ul>
                    </li>
                    <li>
                        上記の利用制限は、法令に基づき許容される範囲（例えば著作権法第30条の4に基づく私的情報解析等）を妨げるものではありません。
                    </li>
                </ol>
            </div>
            <h4>第8条（利用制限および登録抹消）</h4>
            <div class="mb-3">
                貸し本棚は、ユーザーが以下のいずれかに該当する場合には、事前の通知なく、投稿データを削除し、ユーザーに対して本サービスの全部もしくは一部の利用を制限しまたはユーザーとしての登録を抹消することができるものとします。
                <ol>
                    <li>本規約のいずれかの条項に違反した場合</li>
                    <li>本サービスについて、仮登録の状態のまま最終の利用から一定期間利用がない場合</li>
                    <li>その他、貸し本棚が本サービスの利用を適当でないと判断した場合</li>
                </ol>
                前項各号のいずれかに該当した場合、貸し本棚はユーザーのデータを凍結、あるいは削除することができます。<br>
                貸し本棚は、本条に基づき貸し本棚が行った行為によりユーザーに生じた損害について、一切の責任を負いません。
            </div>
            <h4>第9条（退会）</h4>
            <div class="mb-3">
                ユーザーは、貸し本棚の定める退会手続により、本サービスから退会できるものとします。
            </div>
            <h4>第10条（保証の否認および免責事項）</h4>
            <div class="mb-3">
                貸し本棚は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。<br>
                貸し本棚は、本サービスに起因してユーザーに生じたあらゆる損害について一切の責任を負いません。<br>
                貸し本棚は、本サービスに関して、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。
            </div>
            <h4>第11条（サービス内容の変更等）</h4>
            <div class="mb-3">
                貸し本棚は、ユーザーに通知することなく、本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし、これによってユーザーに生じた損害について一切の責任を負いません。
            </div>
            <h4>第12条（利用規約の変更）</h4>
            <div class="mb-3">
                貸し本棚は、必要と判断した場合には、利用規約を変更することがあります。
                原則として変更時には事前に通知するものとし、緊急の変更については事後速やかに通知します。
                なお、本規約の変更後、本サービスの利用を開始した場合には、当該ユーザーは変更後の規約に同意したものとみなします。
            </div>
            <h4>第13条（個人情報の取扱い）</h4>
            <div class="mb-3">
                貸し本棚は、本サービスの利用によって取得する個人情報については、貸し本棚「<router-link to="/privacy">プライバシーポリシー</router-link>」に従い適切に取り扱うものとします。
            </div>
            <h4>第14条（通知または連絡）</h4>
            <div class="mb-3">
                ユーザーと貸し本棚との間の通知または連絡は、貸し本棚の定める方法によって行うものとします。
                貸し本棚は、ユーザーから、貸し本棚が別途定める方式に従った変更届け出がない限り、現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い、これらは、発信時にユーザーへ到達したものとみなします。
            </div>
            <h4>第15条（権利義務の譲渡の禁止）</h4>
            <div class="mb-3">
                ユーザーは、貸し本棚の書面あるいは電磁的方法による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、または担保に供することはできません。
            </div>
            <h4>第16条（準拠法・裁判管轄）</h4>
            <div class="mb-3">
                本規約の解釈にあたっては、日本法を準拠法とします。
                本サービスに関して紛争が生じた場合には、貸し本棚の運営者所在地を管轄する裁判所を専属的合意管轄とします。
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.rule {
    margin: 1rem 0;
    h3 {
        font-size: 1.3rem;
        border-bottom: 1px dashed #ddd;
        margin: .7rem 0;
        padding: .5rem 0;
    }
    h4 {
        font-size: 1.1rem;
    }
}
</style>

<script>
export default {
    mounted() {
        this.useHead({
            title: "利用規約 | 貸し本棚",
            link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ]
        });
    }
}
</script>